const formatVitalName = (key) => {
    let formatted = key.replace(/_/g, ' ');
  
    const specialCases = {
      'blood pressure': 'Blood Pressure',
      'blood sugar': 'Blood Sugar',
      'kidney function': 'Kidney Function',
      'liver function': 'Liver Function',
      'lipid profile': 'Lipid Profile',
      'cbc': 'Complete Blood Count',
      'body temperature': 'Body Temperature',
      'heart rate': 'Heart Rate',
      'respiratory rate': 'Respiratory Rate',
      'oxygen saturation': 'Oxygen Saturation',
    };
  
    formatted = specialCases[formatted.toLowerCase()] || formatted;
  
    if (!specialCases[formatted.toLowerCase()]) {
      formatted = formatted
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }
  
    return formatted;
  };
  
  const formatVitalValue = (key, value) => {
    if (typeof value === 'number') {
      const units = {
        'systolic': 'mmHg',
        'diastolic': 'mmHg',
        'fasting_blood_glucose': 'mg/dL',
        'postprandial_blood_glucose': 'mg/dL',
        'hemoglobin_A1c': '%',
        'serum_creatinine': 'mg/dL',
        'blood_urea_nitrogen': 'mg/dL',
        'estimated_GFR': 'mL/min/1.73m²',
        'electrolytes_sodium': 'mmol/L',
        'electrolytes_potassium': 'mmol/L',
        'body_temperature': '°C',
        'heart_rate': 'bpm',
        'respiratory_rate': 'breaths/min',
        'oxygen_saturation': '%'
      };
  
      const decimalPlaces = {
        'hemoglobin_A1c': 1,
        'body_temperature': 1,
        'oxygen_saturation': 1
      };
  
      const places = decimalPlaces[key] || 0;
      return `${value.toFixed(places)}${units[key] ? ` ${units[key]}` : ''}`;
    }
  
    return value;
  };
  
  const formatVitalForExport = (vital) => {
    const formattedVital = {};
    
    Object.entries(vital).forEach(([key, entries]) => {
      if (Array.isArray(entries)) {
        formattedVital[formatVitalName(key)] = entries.map(entry => {
          const formattedEntry = {};
          Object.entries(entry).forEach(([entryKey, value]) => {
            if (!['id', 'created_at', 'updated_at'].includes(entryKey)) {
              formattedEntry[formatVitalName(entryKey)] = formatVitalValue(entryKey, value);
            }
          });
          return formattedEntry;
        });
      }
    });
  
    return formattedVital;
  };
  
  export { formatVitalName, formatVitalValue, formatVitalForExport };